const ADMIN_PERMISSION = "*:*";

export const VIEW_PERMISSION_MAP = {
    DASHBOARD: ["view:dashboard"],
    INTENT: ["view:intent"],
    TYPOS: ["view:typos"],
    ENTITY: ["view:entity-names"],
    SYNONYM: ["view:synonyms"],
    SELECTOR: ["view:selector"],
    AUTOCOMPLETE: ["view:autocompletes"],
    BULK_TEST: ["view:test"],
    BULK_TEST_RESULT: ["view:result"],
    DEPLOYMENT: ["view:deploy"],
    MEMBER: ["view:member"],
    SETTING: ["view:setting"],
} as const;

const getPermissionView = (permission: string) => {
    return permission.split(':')[1];
};

export const hasAdminPermission = (userPermissions: string[]) => {
    return userPermissions.includes(ADMIN_PERMISSION);
};

const hasPermission = (userPermissions: string[], requiredPermission: string) => {
    return (
        userPermissions.includes(requiredPermission)
            || userPermissions.includes(`*:${getPermissionView(requiredPermission)}`)
    );
};

export const checkPermission = (userPermissions: string[], requiredPermissions: readonly string[]) => {
    return (
        hasAdminPermission(userPermissions)
            || userPermissions.some(permission => getPermissionView(permission) === "*")
            || requiredPermissions.some(requiredPermission => hasPermission(userPermissions, requiredPermission))
    );
};
